<div>
  <p-panel header="Diagnosis Details">
    <label class="font-semibold">Search for the applicable ICD-10 codes:</label>

    <form [formGroup]="searchForm">
      <div class="flex items-center mt-2 gap-4 p-form-widget">
        <div class="field mb-0!">
          <label class="label field-required mr-0">ICD-10 Code:</label>
          <div class="p-field-value">
            <input
              pInputText
              class="icd-search"
              type="text"
              formControlName="icdCode"
              data-test-id="icd-search-input"
            />

            <errors-messages [control]="searchForm.get('icdCode')" />
          </div>
        </div>
        <button
          pButton
          type="button"
          label="Search"
          class="ml-2"
          icon="pi pi-search"
          iconPos="left"
          data-test-id="icd-search-button"
          [loading]="isLoading"
          [disabled]="searchForm.invalid"
          (click)="searchICD()"
        ></button>
      </div>
    </form>

    <div>
      <form [formGroup]="diagnosisForm">
        <div class="grid grid-cols-12 gap-4 pt-4">
          <div class="col-span-12 md:col-span-6">
            <div class="font-semibold mb-1">Select up to 4 ICD codes:</div>

            <p-listbox
              formControlName="selectedIcd"
              data-test-id="icd-search-results-listbox"
              [options]="availableICDs"
              [listStyle]="{ 'height': '18rem' }"
              [readonly]="!canAddICDs"
              (onClick)="selectICD($event)"
            ></p-listbox>
          </div>

          <div class="col-span-12 md:col-span-6">
            <div class="font-semibold mb-1">
              Click the up or down buttons to re-assign Primary, Secondary, Tertiary, and Quaternary Codes:
            </div>

            <p-listbox
              data-test-id="selected-icds-listbox"
              [options]="selectedICDs"
              [listStyle]="{ 'height': '18rem' }"
            >
              <ng-template let-icd let-i="index" pTemplate="item">
                <div class="diagnosis-list-item">
                  <div>({{ orderTypeList[i] }}) - {{ icd.label }}</div>

                  <div class="diagnosis-list-buttons">
                    <button
                      pButton
                      type="button"
                      class="p-button-sm mr-2"
                      icon="pi pi-chevron-up"
                      iconPos="left"
                      data-test-id="move-icd-up-button"
                      [disabled]="i === 0"
                      (click)="moveSelectedICDUp(icd.value)"
                    ></button>

                    <button
                      pButton
                      type="button"
                      class="p-button-sm mr-2"
                      icon="pi pi-chevron-down"
                      iconPos="left"
                      data-test-id="move-icd-down-button"
                      [disabled]="selectedICDs.length - 1 === i"
                      (click)="moveSelectedICDDown(icd.value)"
                    ></button>

                    <button
                      pButton
                      type="button"
                      class="p-button-text p-button-sm"
                      icon="pi pi-times"
                      iconPos="left"
                      data-test-id="remove-icd-button"
                      (click)="removeICD(icd)"
                    ></button>
                  </div>
                </div>
              </ng-template>
            </p-listbox>
          </div>
        </div>
      </form>
    </div>
  </p-panel>

  <div class="flex justify-between pt-6">
    <div>
      <button
        pButton
        severity="danger"
        aria-label="Cancel Create Authorization"
        label="Cancel"
        icon="pi pi-times"
        type="button"
        data-test-id="cancel-request-button"
        (click)="onCancel()"
      ></button>
    </div>

    <div>
      <button
        pButton
        aria-label="Back Step to Authorization Details"
        label="Back"
        icon="pi pi-arrow-left"
        class="p-button-secondary mr-2"
        type="button"
        data-test-id="back-step-button"
        (click)="onClickBack()"
      ></button>
      <button
        pButton
        aria-label="Next Step to Servicing Facility"
        label="Next"
        icon="pi pi-arrow-right"
        iconPos="right"
        type="button"
        data-test-id="next-step-button"
        [disabled]="!isFormValid"
        (click)="onSubmit()"
      ></button>
    </div>
  </div>
</div>
